import React, { useEffect } from 'react';
import Communicateb from './Communicateb';


import AerospaceInsightsCards from './AerospaceInsightsCards';
import CommunicationsButtons from './CommunicationsButtons';
import CommunicationPagedata from './CommunicationPagedata';
import CommunicationPaegeSecondtabs from './CommunicationPaegeSecondtabs';
import Communicationverticaltabs from './Communicationverticaltabs';
import CommunicationCargot from './CommunicationCargot';
import CommunicationBanner from './CommunicationBanner';
import Itrequestform from './Itrequestform';
import Footer from './Footer';
import CommunicationCrigotmobile from './CommunicationCrigotmobile';
import Communicationthirdtab from './Communicationthirdtab';
const CommunicationPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); // Empty dependency array ensures it only runs once when the component mounts
    // Scroll to the top of the page when the component mounts

    return (
        <div style={{ background: '#fff' }}>
            <CommunicationBanner />
            <CommunicationsButtons />
            <CommunicationPagedata />
            <Communicationverticaltabs />

            <CommunicationPaegeSecondtabs />
            <Communicationthirdtab />
            {/* <Crigotpage /> */}
            <CommunicationCargot />
            <div className='mobile-crigot'>
                <CommunicationCrigotmobile />
            </div>

            {/* <AerospaceInsightsCards /> */}
            <br></br>
            <Itrequestform />
            <div style={{ marginTop: "-60px" }}>
                <Footer />
            </div>



            {/* <style>
                {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
            </style> */}
            <style>
        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
      </style>
        </div>
    )
}

export default CommunicationPage;